export const GET_DEALERS_PENDING = 'GET_DEALERS_PENDING'
export const GET_DEALERS_SUCCESSFUL = 'GET_DEALERS_SUCCESSFUL'
export const GET_DEALERS_ERROR = 'GET_DEALERS_ERROR'
export const ENABLE_DEALER = 'ENABLE_DEALER'
export const DISABLE_DEALER = 'DISABLE_DEALER'
export const UPDATE_SOME_DEALERS = 'UPDATE_SOME_DEALERS'
export const UPDATING_DEALERS = 'UPDATING_DEALERS'
export const CLEAR_DEALERS = "CLEAR_DEALERS"
export const DEALER_SEARCH_LIMIT = 25